<template>
  <div class="loading-overlay is-active is-full-page">
    <div class="loading-background"></div>
    <div class="loading-icon"></div>
  </div>
</template>
